<div class="grid grid-cols-1 lg:grid-cols-10 gap-6">
  <div class="col-span-1 lg:col-span-7">
    <div class="mx-auto" id="general">
      @if (!loading || user?.contactId) {
        <div
          class="font-efSans font-bold text-lg md:text-xl text-mat-ef-revolution-primary-500"
          >
          <T
          str="Profile"
          key="customerPortal.customer-portal.profile"
          tags="customer-portal, 3.1"
        ></T>
      </div>
    }

    <mat-divider class="relative w-full"></mat-divider>

    <div class="panel h-15 mx-0">
      <div
        class="header flex items-center justify-between w-full mr-10 p-2.5"
        >
        <div class="flex items-center gap-6">
          @if (!user?.profilePictureUrl || showAltIcon) {
            <div
              class="flex rounded-full text-white text-center font-efSans text-[10px] w-6 h-6 px-0.5 leading-5 my-auto uppercase bg-mat-ef-revolution-primary-500 cursor-pointer"
              >
              <span class="m-auto">{{ user | userinitials | async }}</span>
            </div>
          }

          @if (user?.profilePictureUrl) {
            <div
              class="cursor-pointer rounded-full"
              [ngClass]="{
                'bg-mat-ef-revolution-primary-500 shadow-md h-7 w-7 p-[2px]':
                  !showAltIcon
              }"
              (click)="openUserImgDetails()"
              >
              @if (!showAltIcon) {
                <img
                  class="h-6 w-6 object-cover rounded-full shadow-md"
                  [src]="user?.profilePictureUrl"
                  (error)="showAltIcon = true"
                  alt="profile picture"
                  />
              }
            </div>
          }
          @if (loading) {
            <div class="mt-2.5">
              <ngx-skeleton-loader
                appearance="line"
                animation="progress"
              ></ngx-skeleton-loader>
            </div>
          }
          <div class="text">
            @if (!loading) {
              <div
                class="font-efSans text-sm font-bold text-mat-ef-revolution-primary-500"
                >
                <T
                str="Profile picture"
                key="customerPortal.customer-portal.details.avatar.title"
                tags="customer-portal, 3.1"
              ></T>
            </div>
          }
          @if (loading) {
            <div>
              <ngx-skeleton-loader
                appearance="line"
                animation="progress"
              ></ngx-skeleton-loader>
            </div>
          }

          @if (!loading) {
            <div
              class="font-efSans text-sm text-mat-ef-revolution-grey-two-500"
              >
              (<T
              str="Visible only to me"
              key="customerPortal.customer-portal.only-invisible-for-me"
              tags="customer-portal, 3.1"
              ></T
              >)
            </div>
          }
          @if (loading) {
            <div class="skeleton-margin">
              <ngx-skeleton-loader
                appearance="line"
                animation="progress"
              ></ngx-skeleton-loader>
            </div>
          }
        </div>
      </div>

      @if (!user?.profilePictureUrl && !loading) {
        <button
          data-cy="edit-profile-picture-button"
          mat-button
          mat-raised-button
          class="revolution hidden md:inline-flex small-button"
          color="secondary"
            (click)="
              openUserImgDetails();
              sendContentModulesMiniCTAData('shared.update')
            "
          >
          <mat-icon svgIcon="add_photo_alternate"></mat-icon>
          {{ 'update' | sharedTranslate }}
        </button>
      }
      @if (!user?.profilePictureUrl && !loading) {
        <mat-icon
          svgIcon="add_photo_alternate"
          class="inline-flex md:hidden text-mat-ef-revolution-secondary-500 cursor-pointer"
          (click)="openUserImgDetails()"
        ></mat-icon>
      }
      @if (user?.profilePictureUrl && !loading) {
        <button
          data-cy="edit-profile-picture-button"
          mat-button
          mat-raised-button
          class="revolution hidden md:inline-flex small-button"
          color="secondary"
            (click)="
              openUserImgDetails();
              sendContentModulesMiniCTAData('shared.update')
            "
          >
          <mat-icon svgIcon="create"></mat-icon>
          <ng-container *ngTemplateOutlet="change"></ng-container>
        </button>
      }
      @if (user?.profilePictureUrl && !loading) {
        <mat-icon
          svgIcon="create"
          class="inline-flex md:hidden text-mat-ef-revolution-secondary-500 cursor-pointer"
          (click)="openUserImgDetails()"
        ></mat-icon>
      }
    </div>
  </div>
  <mat-divider class="relative w-full"></mat-divider>

  @if (!loading || user?.contactId) {
    <div
      class="font-efSans font-bold text-lg md:text-xl text-mat-ef-revolution-primary-500 mt-12"
      >
      <T
      str="Contact details"
      key="customerPortal.customer-portal.contact.details"
      tags="customer-portal, 3.1"
    ></T>
  </div>
}
@if (loading && !user?.contactId) {
  <div class="heading-small-skeleton">
    <ngx-skeleton-loader
      appearance="line"
      animation="progress"
    ></ngx-skeleton-loader>
  </div>
}

<mat-divider class="relative w-full"></mat-divider>

<div class="panel h-15 mx-0">
  <div
    class="header flex items-center justify-between w-full mr-10 p-2.5"
    >
    <div class="flex items-center gap-6">
      @if (!loading) {
        <div class="mt-2.5">
          <mat-icon
            class="text-mat-ef-revolution-primary-500"
            svgIcon="person_outline"
          ></mat-icon>
        </div>
      }
      @if (loading) {
        <div class="mt-2.5">
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
          ></ngx-skeleton-loader>
        </div>
      }

      <div class="text">
        @if (!loading) {
          <div
            class="font-efSans text-sm font-bold text-mat-ef-revolution-primary-500"
            >
            <T
            str="Salutation and name"
            key="customerPortal.customer-portal.details.personal.salutation-and-name"
            tags="customer-portal, 3.1"
          ></T>
        </div>
      }
      @if (loading) {
        <div>
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
          ></ngx-skeleton-loader>
        </div>
      }

      @if (!loading && !user.isBusiness) {
        <div
          class="font-efSans text-sm text-mat-ef-revolution-primary-500"
          >
          {{ user | username: true | async }}
        </div>
      }
      @if (!loading && user.isBusiness) {
        <div
          class="font-efSans text-sm text-mat-ef-revolution-primary-500"
          >
          {{ user.companyName }}
        </div>
      }
      @if (loading) {
        <div class="skeleton-margin">
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
          ></ngx-skeleton-loader>
        </div>
      }
    </div>
  </div>
  @if (!notEditable && user && !isPerson() && !loading) {
    <button
      mat-button
      mat-stroked-button
      class="revolution hidden md:inline-flex small-button"
      color="secondary"
            (click)="
              openNameDialog(user);
              sendContentModulesMiniCTAData('shared.update')
            "
      >
      @if (!loading) {
        <mat-icon svgIcon="create"> </mat-icon>
      }
      <ng-container *ngTemplateOutlet="change"></ng-container>
    </button>
  }
  @if (!notEditable && user && !isPerson() && !loading) {
    <mat-icon
      svgIcon="create"
      class="inline-flex md:hidden text-mat-ef-revolution-secondary-500 cursor-pointer"
      (click)="openNameDialog(user)"
    ></mat-icon>
  }
</div>
</div>

<mat-divider class="relative w-full"></mat-divider>

<div class="panel h-15 mx-0">
  <div
    class="header flex items-center justify-between w-full mr-10 p-2.5"
    >
    <div class="flex items-center gap-6">
      @if (!loading) {
        <div class="mt-2.5">
          <mat-icon
            class="text-mat-ef-revolution-primary-500"
            svgIcon="home"
          ></mat-icon>
        </div>
      }
      @if (loading) {
        <div class="mt-2.5">
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
          ></ngx-skeleton-loader>
        </div>
      }

      <div class="text">
        @if (!loading) {
          <div
            class="font-efSans text-sm font-bold text-mat-ef-revolution-primary-500"
            >
            {{ 'address' | sharedTranslate }}
          </div>
        }
        @if (loading) {
          <div>
            <ngx-skeleton-loader
              appearance="line"
              animation="progress"
            ></ngx-skeleton-loader>
          </div>
        }

        @if (!loading && user?.address?.[0]) {
          <div
            data-cy="user-address-text"
            class="font-efSans text-sm text-mat-ef-revolution-primary-500"
            >
            {{ user?.address[0].street ? user?.address[0].street : '' }}
            {{
            user?.address[0].streetNumber
            ? user?.address[0].streetNumber + ', '
            : ', '
            }}
            {{
            user?.address[0].streetAdditional
            ? user?.address[0].streetAdditional + ', '
            : ''
            }}
            {{ user?.address[0].zip ? user?.address[0].zip : '' }}
            {{ user?.address[0].city ? user?.address[0].city : '' }}
          </div>
        }
        @if (!loading && !user?.address?.[0]) {
          <div
            data-cy="user-address-text"
            class="font-efSans text-sm text-mat-ef-revolution-primary-500"
            >
            -
          </div>
        }
        @if (loading) {
          <div class="skeleton-margin">
            <ngx-skeleton-loader
              appearance="line"
              animation="progress"
            ></ngx-skeleton-loader>
          </div>
        }
      </div>
    </div>
    @if (!notEditable && isPerson() && !loading) {
      <button
        data-cy="edit-address-button"
        mat-button
        mat-stroked-button
        class="revolution hidden md:inline-flex small-button"
        color="secondary"
            (click)="
              openAddressDialog(user);
              sendContentModulesMiniCTAData('shared.update')
            "
        >
        @if (!loading) {
          <mat-icon svgIcon="create"> </mat-icon>
        }
        <ng-container *ngTemplateOutlet="change"></ng-container>
      </button>
    }
    @if (!notEditable && isPerson() && !loading) {
      <mat-icon
        svgIcon="create"
        class="inline-flex md:hidden text-mat-ef-revolution-secondary-500 cursor-pointer"
        (click)="openAddressDialog(user)"
      ></mat-icon>
    }
  </div>
</div>
<mat-divider class="relative w-full"></mat-divider>

<div class="panel h-15 mx-0">
  <div
    class="header flex items-center justify-between w-full mr-10 p-2.5"
    >
    <div class="flex items-center gap-6">
      @if (!loading) {
        <div class="mt-2.5">
          <mat-icon
            class="text-mat-ef-revolution-primary-500"
            svgIcon="stay_current_portrait"
          ></mat-icon>
        </div>
      }
      @if (loading) {
        <div class="mt-2.5">
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
          ></ngx-skeleton-loader>
        </div>
      }

      <div class="text">
        @if (!loading) {
          <div
            class="font-efSans text-sm font-bold text-mat-ef-revolution-primary-500"
            >
            {{ 'mobile-number' | sharedTranslate }}
          </div>
        }
        @if (loading) {
          <div>
            <ngx-skeleton-loader
              appearance="line"
              animation="progress"
            ></ngx-skeleton-loader>
          </div>
        }

        @if (!loading && mobile?.mask) {
          <div
            data-cy="user-mobilePersonal-text"
            class="font-efSans text-sm text-mat-ef-revolution-primary-500"
            >
            {{ mobile.prefix }} {{ mobile.phone | mask: mobile.mask }}
          </div>
        }
        @if (!loading && !mobile?.mask) {
          <div
            data-cy="user-mobilePersonal-text"
            class="font-efSans text-sm text-mat-ef-revolution-primary-500"
            >
            {{ mobile ? mobile.number : '-' }}
          </div>
        }

        @if (loading) {
          <div class="skeleton-margin">
            <ngx-skeleton-loader
              appearance="line"
              animation="progress"
            ></ngx-skeleton-loader>
          </div>
        }
      </div>
    </div>
    <div class="flex"
      data-cy="edit-user-mobilePersonal"
      >
      @if (!notEditable && !loading && !mobile) {
        <button
          data-cy="edit-user-mobilePersonal-button"
          mat-button
          mat-stroked-button
          class="revolution hidden md:inline-flex small-button"
          color="secondary"
              (click)="
                openTelephoneDialog(user, 'private');
                sendContentModulesMiniCTAData('shared.update')
              "
          >
          <mat-icon svgIcon="create"></mat-icon>
          <ng-container *ngTemplateOutlet="change"></ng-container>
        </button>
      }
      @if (!notEditable && !loading && !mobile) {
        <mat-icon
          svgIcon="create"
          class="inline-flex md:hidden text-mat-ef-revolution-secondary-500 cursor-pointer"
          (click)="openTelephoneDialog(user, 'private')"
        ></mat-icon>
      }
      @if (!notEditable && !loading && mobile) {
        <div class="cptMenuContainer p-0">
          <customer-portal-app-cpt-menu
            data-cy="edit-user-mobilePersonal-menu"
            [menuType]="'editDeleteMenu'"
            (actionClicked)="mobileActionClicked($event, user)"
            >
          </customer-portal-app-cpt-menu>
        </div>
      }
    </div>
  </div>
</div>
<mat-divider class="relative w-full"></mat-divider>

<div class="panel h-15 mx-0">
  <div
    class="header flex items-center justify-between w-full mr-10 p-2.5"
    >
    <div class="flex items-center gap-6">
      @if (!loading) {
        <div class="mt-2.5">
          <mat-icon
            class="text-mat-ef-revolution-primary-500"
            svgIcon="phone"
          ></mat-icon>
        </div>
      }
      @if (loading) {
        <div class="mt-2.5">
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
          ></ngx-skeleton-loader>
        </div>
      }

      <div class="text">
        @if (!loading) {
          <div
            class="font-efSans text-sm font-bold text-mat-ef-revolution-primary-500"
            >
            <T
            str="Landline"
            key="customerPortal.customer-portal.details.personal.landline"
            tags="customer-portal, 3.1"
          ></T>
        </div>
      }
      @if (loading) {
        <div>
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
          ></ngx-skeleton-loader>
        </div>
      }

      @if (!loading && landlinePersonal?.mask) {
        <div
          data-cy="user-landlinePersonal-text"
          class="font-efSans text-sm text-mat-ef-revolution-primary-500"
          >
          {{ landlinePersonal.prefix }}
          {{ landlinePersonal.phone | mask: landlinePersonal.mask }}
        </div>
      }
      @if (!loading && !landlinePersonal?.mask) {
        <div
          data-cy="user-landlinePersonal-text"
          class="font-efSans text-sm text-mat-ef-revolution-primary-500"
          >
          {{ landlinePersonal ? landlinePersonal.number : '-' }}
        </div>
      }

      @if (loading) {
        <div class="skeleton-margin">
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
          ></ngx-skeleton-loader>
        </div>
      }
    </div>
  </div>
  @if (!notEditable && !loading) {
    <div
      class="flex"
      data-cy="edit-user-landlinePersonal"
      >
      @if (!landlinePersonal) {
        <button
          data-cy="edit-user-landlinePersonal-button"
          mat-button
          mat-stroked-button
          class="revolution hidden md:inline-flex small-button"
          color="secondary"
              (click)="
                openNumberLandline(user);
                sendContentModulesMiniCTAData('shared.update')
              "
          >
          <mat-icon svgIcon="create"></mat-icon>
          <ng-container *ngTemplateOutlet="change"></ng-container>
        </button>
      }
      @if (!landlinePersonal) {
        <mat-icon
          svgIcon="create"
          class="inline-flex md:hidden text-mat-ef-revolution-secondary-500 cursor-pointer"
          (click)="openNumberLandline(user)"
          >
        </mat-icon>
      }
      @if (landlinePersonal) {
        <div class="cptMenuContainer p-0">
          <customer-portal-app-cpt-menu
            data-cy="edit-user-landlinePersonal-menu"
            [menuType]="'editDeleteMenu'"
            (actionClicked)="landlinePersonalActionClicked($event, user)"
            >
          </customer-portal-app-cpt-menu>
        </div>
      }
    </div>
  }
</div>
</div>
<mat-divider class="relative w-full"></mat-divider>

<div class="panel h-15 mx-0">
  <div
    class="header flex items-center justify-between w-full mr-10 p-2.5"
    >
    <div class="flex items-center gap-6">
      @if (!loading) {
        <div class="mt-2.5">
          <mat-icon
            class="text-mat-ef-revolution-primary-500"
            svgIcon="stay_current_portrait"
          ></mat-icon>
        </div>
      }
      @if (loading) {
        <div class="mt-2.5">
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
          ></ngx-skeleton-loader>
        </div>
      }

      <div class="text">
        @if (!loading) {
          <div
            class="font-efSans text-sm font-bold text-mat-ef-revolution-primary-500"
            >
            <T
            str="Company number - mobile"
            key="customerPortal.customer-portal.details.business.mobile"
            tags="customer-portal, 3.1"
          ></T>
        </div>
      }
      @if (loading) {
        <div>
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
          ></ngx-skeleton-loader>
        </div>
      }

      @if (!loading && mobileBusiness?.mask) {
        <div
          data-cy="user-mobileBusiness-text"
          class="font-efSans text-sm text-mat-ef-revolution-primary-500"
          >
          {{ mobileBusiness.prefix }}
          {{ mobileBusiness.phone | mask: mobileBusiness.mask }}
        </div>
      }
      @if (!loading && !mobileBusiness?.mask) {
        <div
          data-cy="user-mobileBusiness-text"
          class="font-efSans text-sm text-mat-ef-revolution-primary-500"
          >
          {{ mobileBusiness ? mobileBusiness.number : '-' }}
        </div>
      }

      @if (loading) {
        <div class="skeleton-margin">
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
          ></ngx-skeleton-loader>
        </div>
      }
    </div>
  </div>
  <div class="flex"
    data-cy="edit-user-mobileBusiness"
    >
    @if (!notEditable && !loading && !mobileBusiness) {
      <button
        data-cy="edit-user-mobileBusiness-button"
        mat-button
        mat-stroked-button
        class="revolution hidden md:inline-flex small-button"
        color="secondary"
              (click)="
                openTelephoneDialog(user, 'business');
                sendContentModulesMiniCTAData('shared.update')
              "
        >
        <mat-icon svgIcon="create"></mat-icon>
        <ng-container *ngTemplateOutlet="change"></ng-container>
      </button>
    }
    @if (!notEditable && !loading && !mobileBusiness) {
      <mat-icon
        svgIcon="create"
        class="inline-flex md:hidden text-mat-ef-revolution-secondary-500 cursor-pointer"
        (click)="openTelephoneDialog(user, 'business')"
      ></mat-icon>
    }
    @if (!notEditable && !loading && mobileBusiness) {
      <div
        class="cptMenuContainer p-0"
        >
        <customer-portal-app-cpt-menu
          data-cy="edit-user-mobileBusiness-menu"
          [menuType]="'editDeleteMenu'"
          (actionClicked)="mobileBusinessActionClicked($event, user)"
          >
        </customer-portal-app-cpt-menu>
      </div>
    }
  </div>
</div>
</div>
<mat-divider class="relative w-full"></mat-divider>

<div class="panel h-15 mx-0">
  <div
    class="header flex items-center justify-between w-full mr-10 p-2.5"
    >
    <div class="flex items-center gap-6">
      @if (!loading) {
        <div class="mt-2.5">
          <mat-icon
            class="text-mat-ef-revolution-primary-500"
            svgIcon="phone"
          ></mat-icon>
        </div>
      }
      @if (loading) {
        <div class="mt-2.5">
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
          ></ngx-skeleton-loader>
        </div>
      }

      <div class="text">
        @if (!loading) {
          <div
            class="font-efSans text-sm font-bold text-mat-ef-revolution-primary-500"
            >
            <T
            str="Company number - landline"
            key="customerPortal.customer-portal.details.business.landline"
            tags="customer-portal, 3.1"
          ></T>
        </div>
      }
      @if (loading) {
        <div>
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
          ></ngx-skeleton-loader>
        </div>
      }

      @if (!loading && landlineBusiness?.mask) {
        <div
          data-cy="user-landlineBusiness-text"
          class="font-efSans text-sm text-mat-ef-revolution-primary-500"
          >
          {{ landlineBusiness.prefix }}
          {{ landlineBusiness.phone | mask: landlineBusiness.mask }}
        </div>
      }
      @if (!loading && !landlineBusiness?.mask) {
        <div
          data-cy="user-landlineBusiness-text"
          class="font-efSans text-sm text-mat-ef-revolution-primary-500"
          >
          {{ landlineBusiness ? landlineBusiness.number : '-' }}
        </div>
      }

      @if (loading) {
        <div class="skeleton-margin">
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
          ></ngx-skeleton-loader>
        </div>
      }
    </div>
  </div>

  @if (!notEditable && !loading) {
    <div
      class="flex"
      data-cy="edit-user-landlineBusiness"
      >
      @if (!landlineBusiness) {
        <button
          data-cy="edit-user-landlineBusiness-button"
          mat-button
          mat-stroked-button
          class="revolution hidden md:inline-flex small-button"
          color="secondary"
              (click)="
                openCompanyNumberLandline(user);
                sendContentModulesMiniCTAData('shared.update')
              "
          >
          <mat-icon svgIcon="create"></mat-icon>
          <ng-container *ngTemplateOutlet="change"></ng-container>
        </button>
      }
      @if (!landlineBusiness) {
        <mat-icon
          svgIcon="create"
          class="inline-flex md:hidden text-mat-ef-revolution-secondary-500 cursor-pointer"
          (click)="openCompanyNumberLandline(user)"
        ></mat-icon>
      }
      @if (landlineBusiness) {
        <div class="cptMenuContainer p-0">
          <customer-portal-app-cpt-menu
            data-cy="edit-user-landlineBusiness-menu"
            [menuType]="'editDeleteMenu'"
            (actionClicked)="landlineBusinessActionClicked($event, user)"
            >
          </customer-portal-app-cpt-menu>
        </div>
      }
    </div>
  }
</div>
</div>
<mat-divider class="relative w-full"></mat-divider>

<div class="panel h-15 mx-0">
  <div
    class="header flex items-center justify-between w-full mr-10 p-2.5"
    >
    <div class="flex items-center gap-6">
      @if (!loading) {
        <div class="mt-2.5">
          <mat-icon
            class="text-mat-ef-revolution-primary-500"
            svgIcon="cake"
          ></mat-icon>
        </div>
      }
      @if (loading) {
        <div class="mt-2.5">
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
          ></ngx-skeleton-loader>
        </div>
      }

      <div class="text">
        @if (!loading) {
          <div
            class="font-efSans text-sm font-bold text-mat-ef-revolution-primary-500"
            >
            {{ 'date-of-birth' | sharedTranslate }}
          </div>
        }
        @if (loading) {
          <div>
            <ngx-skeleton-loader
              appearance="line"
              animation="progress"
            ></ngx-skeleton-loader>
          </div>
        }

        @if (!loading) {
          <div
            data-cy="user-birthday-text"
            class="font-efSans text-sm text-mat-ef-revolution-primary-500"
            >
            {{
            user && user?.birthDate
            ? (user?.birthDate | date: dateFormat)
            : '-'
            }}
          </div>
        }
        @if (loading) {
          <div class="skeleton-margin">
            <ngx-skeleton-loader
              appearance="line"
              animation="progress"
            ></ngx-skeleton-loader>
          </div>
        }
      </div>
    </div>
    @if (!notEditable && !loading) {
      <button
        data-cy="edit-birthday-button"
        mat-button
        mat-stroked-button
        class="revolution hidden md:inline-flex small-button"
        color="secondary"
            (click)="
              openBirthdateDialog(user);
              sendContentModulesMiniCTAData('shared.update')
            "
        >
        <mat-icon svgIcon="create"></mat-icon>
        <ng-container *ngTemplateOutlet="change"></ng-container>
      </button>
    }
    @if (!notEditable && !loading) {
      <mat-icon
        svgIcon="create"
        class="inline-flex md:hidden text-mat-ef-revolution-secondary-500 cursor-pointer"
        (click)="openBirthdateDialog(user)"
      ></mat-icon>
    }
  </div>
</div>

<mat-divider class="relative w-full"></mat-divider>

<div class="panel h-15 mx-0">
  <div
    class="header flex items-center justify-between w-full mr-10 p-2.5"
    >
    <div class="flex items-center gap-6">
      @if (!loading) {
        <div class="mt-2.5">
          <mat-icon
            class="text-mat-ef-revolution-primary-500"
            svgIcon="drivers_license"
          ></mat-icon>
        </div>
      }
      @if (loading) {
        <div class="mt-2.5">
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
          ></ngx-skeleton-loader>
        </div>
      }

      <div class="text">
        @if (!loading) {
          <div
            class="font-efSans text-sm font-bold text-mat-ef-revolution-primary-500"
            >
            {{ 'care-id' | sharedTranslate }}
          </div>
        }
        @if (loading) {
          <div>
            <ngx-skeleton-loader
              appearance="line"
              animation="progress"
            ></ngx-skeleton-loader>
          </div>
        }

        @if (!loading) {
          <div
            data-cy="user-careId-text"
            class="font-efSans text-sm text-mat-ef-revolution-primary-500"
            >
            {{ user?.careId ?? '-' }}
          </div>
        }
        @if (loading) {
          <div class="skeleton-margin">
            <ngx-skeleton-loader
              appearance="line"
              animation="progress"
            ></ngx-skeleton-loader>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<mat-divider class="relative w-full"></mat-divider>

@if (!loading || user?.contactId) {
  <div
    class="font-efSans font-bold text-lg md:text-xl text-mat-ef-revolution-primary-500 mt-12"
    >
    <T
    str="Login details"
    key="customerPortal.customer-portal.credentials"
    tags="customer-portal, 3.1"
  ></T>
</div>
}
@if (loading && !user?.contactId) {
  <div class="heading-small-skeleton">
    <ngx-skeleton-loader
      appearance="line"
      animation="progress"
    ></ngx-skeleton-loader>
  </div>
}

<mat-divider class="relative w-full"></mat-divider>
<mat-expansion-panel
  #email
  [disabled]="!hasPendingEmailChange()"
        (afterExpand)="
          sendContentModulesData(
            true,
            'customerPortal.customer-portal.details.login.email'
          )
        "
        (afterCollapse)="
          sendContentModulesData(
            false,
            'customerPortal.customer-portal.details.login.email'
          )
        "
  class="py-0 pr-0"
  >
  <mat-expansion-panel-header
    class="px-0"
    [collapsedHeight]="'auto'"
    [expandedHeight]="'auto'"
    data-cy="email-change-section"
    >
    <mat-panel-title class="mr-0">
      <div class="header flex items-center justify-between w-full">
        <div class="flex items-center gap-6">
          @if (!loading) {
            <div class="mt-2.5">
              <mat-icon
                class="text-mat-ef-revolution-primary-500"
                svgIcon="alternate_email"
              ></mat-icon>
            </div>
          }
          @if (loading) {
            <div class="mt-2.5">
              <ngx-skeleton-loader
                appearance="line"
                animation="progress"
              ></ngx-skeleton-loader>
            </div>
          }

          <div class="text">
            @if (!loading) {
              <div
                class="font-efSans text-sm font-bold text-mat-ef-revolution-primary-500"
                >
                <T
                str="E-Mail-Adresse"
                key="customerPortal.customer-portal.details.login.email"
                tags="customer-portal, 3.1"
              ></T>
              @if (hasPendingEmailChange()) {
                <div
                  class="hasPendingEmailChange"
                  >
                  <T
                  str="Email address change pending"
                  key="customerPortal.customer-portal.details.pending-email-change"
                  tags="customer-portal, 3.1"
                ></T>
              </div>
            }
          </div>
        }
        @if (loading) {
          <div>
            <ngx-skeleton-loader
              appearance="line"
              animation="progress"
            ></ngx-skeleton-loader>
          </div>
        }

        @if (!loading) {
          <div
            class="font-efSans text-sm text-mat-ef-revolution-primary-500"
            data-cy="user-email"
            >
            {{ user?.email }}
          </div>
        }
        @if (loading) {
          <div class="skeleton-margin">
            <ngx-skeleton-loader
              appearance="line"
              animation="progress"
            ></ngx-skeleton-loader>
          </div>
        }
      </div>
    </div>
    @if (!notEditable && !hasPendingEmailChange()) {
      <div>
        <button
          mat-button
          mat-stroked-button
          class="revolution hidden md:inline-flex small-button mr-[2px]"
          color="secondary"
          data-cy="edit-user-email-button"
                  (click)="
                    openEmailDialog(user);
                    sendContentModulesMiniCTAData('shared.update')
                  "
          >
          <mat-icon svgIcon="create"></mat-icon>
          <ng-container *ngTemplateOutlet="change"></ng-container>
        </button>
        <mat-icon
          svgIcon="create"
          class="inline-flex md:hidden text-mat-ef-revolution-secondary-500 cursor-pointer"
          (click)="openEmailDialog(user)"
          >
        </mat-icon>
      </div>
    }
  </div>
</mat-panel-title>
</mat-expansion-panel-header>

<div class="ml-6 mt-2">
  <div class="flex flex-col md:flex-row gap-6">
    <div class="text">
      <div
        class="font-efSans text-sm font-bold text-mat-ef-revolution-primary-500"
        >
        <T
        str="New email address"
        key="customerPortal.customer-portal.details.pending-email-change.new-mail"
        tags="customer-portal, 3.1"
      ></T>
    </div>

    <div
      class="font-efSans text-sm text-mat-ef-revolution-primary-500 font-normal"
      >
      {{ emailChangeDetails?.newEmail }}
    </div>
  </div>

  <div class="text">
    <div
      class="font-efSans text-sm font-bold text-mat-ef-revolution-primary-500"
      >
      <T
      str="Valid until"
      key="customerPortal.customer-portal.details.pending-email-change.valid-until"
      tags="customer-portal, 3.1"
    ></T>
  </div>

  <div
    class="font-efSans text-sm text-mat-ef-revolution-primary-500 font-normal"
    >
    {{
    emailChangeDetails?.validTo
    ? (emailChangeDetails?.validTo | date: 'dd.MM.yyyy HH:mm')
    : '-'
    }}
  </div>
</div>
</div>

@if (!notEditable) {
  <mat-divider class="relattive w-full my-4"></mat-divider>
  <div class="relative -r-10 w-full mt-5">
    <button
      class="revolution float-right"
      mat-button
      mat-raised-button
      color="secondary"
      data-cy="pending-edit-user-email-button"
      (click)="openEmailDialog(user)"
      >
      <T
      str="Update e-mail"
      key="customerPortal.customer-portal.details.change.email"
      tags="customer-portal, 3.1"
    ></T>
  </button>
</div>
}

</div>
</mat-expansion-panel>
<mat-divider class="relative w-full"></mat-divider>
<div class="panel h-15 mx-0">
  <div
    class="header flex items-center justify-between w-full mr-10 p-2.5"
    >
    <div class="flex items-center gap-6">
      @if (!loading) {
        <div class="mt-2.5">
          <mat-icon
            class="text-mat-ef-revolution-primary-500"
            svgIcon="lock"
          ></mat-icon>
        </div>
      }
      @if (loading) {
        <div class="mt-2.5">
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
          ></ngx-skeleton-loader>
        </div>
      }

      <div class="text">
        @if (!loading) {
          <div
            class="font-efSans text-sm font-bold text-mat-ef-revolution-primary-500"
            >
            {{ 'password' | sharedTranslate }}
          </div>
        }
        @if (loading) {
          <div>
            <ngx-skeleton-loader
              appearance="line"
              animation="progress"
            ></ngx-skeleton-loader>
          </div>
        }

        @if (!loading) {
          <div
            class="font-efSans text-sm text-mat-ef-revolution-primary-500"
            >
            <T
            str="Last updated on:"
            key="customerPortal.customer-portal.details.password-message"
            tags="customer-portal, 3.1"
          ></T>
          {{ date ? (date | date: dateFormat) : ' - ' }}
        </div>
      }
      @if (loading) {
        <div class="skeleton-margin">
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
          ></ngx-skeleton-loader>
        </div>
      }
    </div>
  </div>
  @if (!loading) {
    <button
      mat-button
      mat-stroked-button
      class="revolution hidden md:inline-flex small-button"
      color="secondary"
            (click)="
              openPasswordDialog(user);
              sendContentModulesMiniCTAData('shared.update')
            "
      >
      <mat-icon svgIcon="create"></mat-icon>
      <ng-container *ngTemplateOutlet="change"></ng-container>
    </button>
  }
  @if (!loading) {
    <mat-icon
      svgIcon="create"
      class="inline-flex md:hidden text-mat-ef-revolution-secondary-500 cursor-pointer"
      (click)="openPasswordDialog(user)"
    ></mat-icon>
  }
</div>
</div>

<mat-divider class="relative w-full"></mat-divider>

@if (!loading || user?.contactId) {
  <div
    class="font-efSans font-bold text-lg md:text-xl text-mat-ef-revolution-primary-500 mt-12"
    >
    <T
    str="Account settings"
    key="customerPortal.customer-portal.account-settings"
    tags="customer-portal, 3.1"
  ></T>
</div>
}
@if (loading && !user?.contactId) {
  <div class="heading-small-skeleton">
    <ngx-skeleton-loader
      appearance="line"
      animation="progress"
    ></ngx-skeleton-loader>
  </div>
}
<mat-divider class="relative w-full"></mat-divider>
<div class="panel h-15 mx-0">
  <div
    class="header flex items-center justify-between w-full mr-10 p-2.5"
    >
    <div class="flex items-center gap-6">
      @if (!loading) {
        <div class="mt-2.5">
          <mat-icon
            class="text-mat-ef-revolution-primary-500"
            svgIcon="language"
          ></mat-icon>
        </div>
      }
      @if (loading) {
        <div class="mt-2.5">
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
          ></ngx-skeleton-loader>
        </div>
      }

      <div class="text">
        @if (!loading) {
          <div
            class="font-efSans text-sm font-bold text-mat-ef-revolution-primary-500"
            >
            <T
            str="Language"
            key="customerPortal.customer-portal.details.language"
            tags="customer-portal, 3.1"
          ></T>
        </div>
      }
      @if (loading) {
        <div>
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
          ></ngx-skeleton-loader>
        </div>
      }

      @if (!loading) {
        <div
          class="font-efSans text-sm text-mat-ef-revolution-primary-500"
          >
          {{ lang ? lang : '-' }}
        </div>
      }
      @if (loading) {
        <div class="skeleton-margin">
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
          ></ngx-skeleton-loader>
        </div>
      }
    </div>
  </div>

  @if (!notEditable && !loading) {
    <button
      mat-button
      mat-stroked-button
      class="revolution hidden md:inline-flex small-button"
      color="secondary"
            (click)="
              openLanguageDialog(user);
              sendContentModulesMiniCTAData('shared.update')
            "
      >
      <mat-icon svgIcon="create"></mat-icon>
      <ng-container *ngTemplateOutlet="change"></ng-container>
    </button>
  }
  @if (!notEditable && !loading) {
    <mat-icon
      svgIcon="create"
      class="inline-flex md:hidden text-mat-ef-revolution-secondary-500 cursor-pointer"
      (click)="openLanguageDialog(user)"
    ></mat-icon>
  }
</div>
</div>

<mat-divider class="relative w-full"></mat-divider>
<mat-expansion-panel
  data-cy="user-account-delete-panel"
  (afterExpand)="sendContentModulesData(true, 'shared.account-delete')"
  (afterCollapse)="sendContentModulesData(false, 'shared.account-delete')"
  #email
  class="py-0 pr-0"
  >
  <mat-expansion-panel-header
    class="px-0"
    [collapsedHeight]="'auto'"
    [expandedHeight]="'auto'"
    >
    <mat-panel-title class="mr-0">
      <div class="header flex items-center justify-between w-full">
        <div class="flex items-center gap-6">
          @if (!loading) {
            <div class="mt-2.5">
              <mat-icon
                class="text-mat-ef-revolution-primary-500"
                svgIcon="account_circle"
              ></mat-icon>
            </div>
          }
          @if (loading) {
            <div class="mt-2.5">
              <ngx-skeleton-loader
                appearance="line"
                animation="progress"
              ></ngx-skeleton-loader>
            </div>
          }

          <div class="text">
            @if (!loading) {
              <div
                class="font-efSans text-sm font-bold text-mat-ef-revolution-primary-500"
                >
                {{ 'account-delete' | sharedTranslate }}
              </div>
            }
            @if (loading) {
              <div>
                <ngx-skeleton-loader
                  appearance="line"
                  animation="progress"
                ></ngx-skeleton-loader>
              </div>
            }

            @if (!loading) {
              <div
                class="font-efSans text-sm text-mat-ef-revolution-primary-500"
                >
                <T
                str="Delete your account"
                key="customerPortal.customer-portal.details.delete-account-message"
                tags="customer-portal, 3.1"
              ></T>
            </div>
          }
          @if (loading) {
            <div class="skeleton-margin">
              <ngx-skeleton-loader
                appearance="line"
                animation="progress"
              ></ngx-skeleton-loader>
            </div>
          }
        </div>
      </div>
    </div>
  </mat-panel-title>
</mat-expansion-panel-header>
<div class="ml-6">
  <div class="grid gap-6">
    <h3 class="font-efSans text-lg text-mat-ef-revolution-red-500 mt-6">
      <T
      str="Important NOTE!"
      key="customerPortal.customer-portal.details.delete.account.heading"
      tags="customer-portal, 3.1"
    ></T>
  </h3>
  <p
    class="delete-consent font-efSans text-sm text-mat-ef-revolution-primary-500 text-justify font-normal"
    >
    <T
    str="After deleting your Emil Frey customer portal account, you can no longer log in to the customer portal with your access data. The deletion of the account in the customer portal has no effect on other accounts that you have created on the websites and applications of the Emil Frey Group. The data on your other Emil Frey Group accounts will be retained. If you wish, you can register again for the Emil Frey customer portal with new access data. In doing so, however, you will lose the previous settings and all the data you uploaded in the deleted account. Before you delete your account, please download your files and images uploaded in the customer portal to avoid data loss."
    key="customerPortal.customer-portal.details.delete.account.note"
    tags="customer-portal, 3.1"
  ></T>
</p>
<mat-checkbox
  data-cy="user-account-delete-checkbox"
  [formControl]="note"
  (change)="checkIfSelected()"
  color="primary"
  class="consent-checkbox font-efSans text-sm text-mat-ef-revolution-primary-500 text-justify leading-none"
  >
  <T
  str="I have understood the information and I agree that my myEmil Frey customer portal account will definitely be deleted."
  key="customerPortal.customer-portal.details.delete.account.consent"
  tags="customer-portal, 3.1"
></T>
</mat-checkbox>
</div>
<div class="relative -r-10 w-full mt-5">
  <button
    data-cy="user-account-delete-button"
    mat-button
    mat-stroked-button
    class="revolution float-right"
    [disabled]="disable"
    (click)="deleteAccount(user)"
    color="warn"
    >
    <mat-icon svgIcon="delete"></mat-icon>
    {{ 'account-delete' | sharedTranslate }}
  </button>
</div>
</div>
</mat-expansion-panel>

<mat-divider class="relative w-full"></mat-divider>
</div>
</div>

<div class="col-span-1 lg:col-span-3 flex flex-col gap-6">
  @if (hasDrivingLicense) {
    <div
      class="rounded-xl bg-mat-ef-revolution-grey-200 mt-11"
      >
      <div class="p-6">
        <p
          class="font-efSans text-[15px] font-bold text-mat-ef-revolution-primary-500 mb-3"
          >
          <T
          str="Driver's license"
          key="customerPortal.customer-portal.details.driving-licence"
          tags="customer-portal, 3.1"
        ></T>
      </p>
      @if (!documents.back && !documents.front) {
        <p
          class="font-efSans text-sm text-mat-ef-revolution-primary-500"
          >
          <T
          str="Save time during your next visit at the dealership and add your driving licence to your profile."
          key="customerPortal.customer-portal.driver-licence-to-your-profile"
          tags="customer-portal, 3.1"
        ></T>
      </p>
    }
    @if (documents.back || documents.front) {
      <p
        class="font-efSans text-sm text-mat-ef-revolution-primary-500"
        >
        <T
        str="Manage your driving licence documents"
        key="customerPortal.customer-portal.manage-your-driving-licence"
        tags="customer-portal, 3.1"
      ></T>
    </p>
  }
  @if (documents.back || documents.front) {
    <div
      class="driver-licence mt-5 gap-3"
      >
      <div
        data-cy="edit-driving-license-front"
        [matTooltip]="tooltipFrontText"
        class="w-full col-span-1 lg:w-[118px] h-40 lg:h-[73px] flex flex-wrap align-center relative cursor-pointer bg-white rounded-lg"
        (click)="loadLicence('front')"
        >
        @if (!documents.front || documents.front === 'front') {
          <div
            class="w-full flex justify-center items-center cursor-pointer"
            >
            <mat-icon
              svgIcon="add_photo_alternate"
              class="text-xs ml-2 text-mat-ef-revolution-primary-500"
            ></mat-icon>
          </div>
        }
        @if (documents.front && documents.front !== 'front') {
          <div
            class="image-preview rounded-lg bg-center bg-cover z-10 absolute cursor-pointer w-full h-full"
            >
            <img
              alt="document - front"
              [src]="documents.front"
              class="w-full h-full rounded-lg"
              />
          </div>
          <div class="absolute r-2.5 t-2.5 z-10 opacity-0">
            <button mat-button>
              <mat-icon
                class="text-mat-ef-revolution-primary-500"
                svgIcon="create"
              ></mat-icon>
            </button>
          </div>
        }
      </div>
      <div
        data-cy="edit-driving-license-back"
        [matTooltip]="tooltipBackText"
        class="w-full col-span-1 lg:w-[118px] h-40 lg:h-[73px] flex flex-wrap align-center relative cursor-pointer bg-white rounded-lg"
        (click)="loadLicence('back')"
        >
        @if (!documents.back || documents.back === 'back') {
          <div
            class="w-full flex justify-center items-center cursor-pointer"
            >
            <mat-icon
              svgIcon="add_photo_alternate"
              class="text-xs ml-2 text-mat-ef-revolution-primary-500"
            ></mat-icon>
          </div>
        }
        @if (documents.back && documents.back !== 'back') {
          <div
            class="image-preview rounded-lg bg-center bg-cover z-10 absolute cursor-pointer w-full h-full"
            >
            <img
              alt="document - back"
              [src]="documents.back"
              class="w-full h-full rounded-lg"
              />
          </div>
          <div class="absolute r-2.5 t-2.5 z-10 opacity-0">
            <button mat-button>
              <mat-icon
                class="text-mat-ef-revolution-primary-500"
                svgIcon="create"
              ></mat-icon>
            </button>
          </div>
        }
      </div>
    </div>
  }
  @if (!documents.back && !documents.front) {
    <button
      data-cy="edit-driving-license-upload-now"
      mat-button
      mat-stroked-button
      class="revolution medium-button mt-4"
      color="secondary"
          (click)="
            documents.back = 'back';
            documents.front = 'front';
            sendContentModulesCTAData(
              'customerPortal.customer-portal.upload.now'
            )
          "
      >
      <T
      str="Upload now"
      key="customerPortal.customer-portal.upload.now"
      tags="customer-portal, 3.1"
    ></T>
  </button>
}
</div>
</div>
}

@if (hasFAQ) {
  <customer-portal-app-faq-card
    [alwaysSmall]="true"
  ></customer-portal-app-faq-card>
}

<customer-portal-app-user-notice-card
  [mode]="'generalUserData'"
  (showUserNoticeCard)="setShowUserNoticeCard($event)"
  >
</customer-portal-app-user-notice-card>
</div>
</div>

<ng-template #change>
  {{ 'update' | sharedTranslate }}
</ng-template>
